import { validCartURL } from './ulti-commerce-core.js';

const drawer = document.getElementById('ulti-cart-drawer');
if (drawer) {
  const lines = drawer.querySelector('[data-cart-lines]');
  const status = drawer.querySelector('[data-cart-status]');
  const summary = drawer.querySelector('[data-cart-summary]');
  const offer = drawer.querySelector('[data-cart-offer]');
  const recommendations = drawer.querySelector('[data-cart-recommendations]');
  const checkout = drawer.querySelector('[data-cart-checkout]');
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let refreshing;
  let focusReturn;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: drawer.dataset.currency || 'SGD' }).format(cents / 100);
  function node(tag, className, text) {
    const element = document.createElement(tag);
    element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  function lock(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    lines.querySelectorAll('button,input').forEach(control => { control.disabled = value; });
    drawer.querySelectorAll('[data-cart-upsell-add]').forEach(control => { control.disabled = value; });
    checkout.setAttribute('aria-disabled', String(value));
  }
  function renderOffer(cart) {
    if (!offer) return;
    const subtotal = cart.items_subtotal_price ?? cart.total_price;
    const threshold = Number(offer.dataset.cartOfferThreshold || 0);
    const code = offer.dataset.cartOfferCode || '';
    const hasItems = cart.items.length > 0;
    const eligible = subtotal >= threshold;
    const progress = threshold ? Math.min(100, Math.round((subtotal / threshold) * 100)) : 100;
    offer.hidden = !hasItems;
    offer.querySelector('[data-cart-offer-progress]').style.width = `${progress}%`;
    offer.querySelector('[data-cart-offer-progress]').parentElement.setAttribute('aria-valuenow', String(progress));
    if (eligible) {
      offer.querySelector('[data-cart-offer-copy]').textContent = 'Your S$15 off S$100 offer is ready.';
      offer.querySelector('[data-cart-offer-detail]').textContent = 'Your code is applied automatically when you continue to checkout.';
      checkout.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}checkout`)}`;
    } else {
      offer.querySelector('[data-cart-offer-copy]').textContent = `Add ${money(threshold - subtotal)} more to unlock S$15 off.`;
      offer.querySelector('[data-cart-offer-detail]').textContent = 'Valid on S$100+ cart subtotals until 3 Nov. One use per customer.';
      checkout.href = `${root}checkout`;
    }
  }
  function renderRecommendations(cart) {
    if (!recommendations) return;
    const inCart = new Set(cart.items.map(item => String(item.product_id)));
    let shown = 0;
    recommendations.querySelectorAll('[data-cart-upsell]').forEach(card => {
      const hide = inCart.has(card.dataset.cartUpsellProductId);
      card.hidden = hide;
      if (!hide) shown += 1;
    });
    recommendations.hidden = cart.items.length === 0 || shown === 0;
  }
  function render(cart) {
    drawer.dataset.currency = cart.currency || drawer.dataset.currency;
    lines.replaceChildren();
    document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    summary.hidden = cart.items.length === 0;
    if (!cart.items.length) {
      lines.append(node('p', 'ulti-cart-empty', "There's nothing here yet."));
      const link = node('a', 'ulti-button', 'Continue shopping'); link.href = root; lines.append(link);
    }
    for (const item of cart.items) {
      const row = node('article', 'ulti-cart-line');
      if (item.image) {
        const img = node('img', ''); img.src = item.image; img.alt = item.product_title; img.width = 88; img.height = 88; img.loading = 'lazy'; row.append(img);
      }
      const details = node('div', 'ulti-cart-line-info');
      const title = node('a', 'ulti-cart-product-title', item.product_title); title.href = validCartURL(item.url, location.origin); details.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', 'ulti-cart-options', item.variant_title));
      if (item.selling_plan_allocation?.selling_plan?.name) details.append(node('p', 'ulti-cart-options', item.selling_plan_allocation.selling_plan.name));
      for (const [key, value] of Object.entries(item.properties || {})) {
        if (!key.startsWith('_') && value) details.append(node('p', 'ulti-cart-options', `${key}: ${value}`));
      }
      const price = node('p', 'ulti-cart-line-price');
      if (item.original_line_price > item.final_line_price) price.append(node('s', '', money(item.original_line_price)), document.createTextNode(' '));
      price.append(node('strong', '', money(item.final_line_price))); details.append(price);
      for (const discount of item.line_level_discount_allocations || []) details.append(node('p', 'ulti-cart-discount', discount.discount_application.title));
      const controls = node('div', 'ulti-cart-line-controls');
      const decrease = node('button', '', '-'); decrease.type = 'button'; decrease.setAttribute('aria-label', `Decrease quantity of ${item.product_title}`);
      const quantity = node('span', '', String(item.quantity)); quantity.setAttribute('aria-label', `Quantity: ${item.quantity}`);
      const increase = node('button', '', '+'); increase.type = 'button'; increase.setAttribute('aria-label', `Increase quantity of ${item.product_title}`);
      const remove = node('button', 'ulti-cart-remove', 'Remove'); remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${item.product_title}`);
      const increment = item.quantity_rule?.increment || 1;
      decrease.addEventListener('click', () => change(item.key, Math.max(0, item.quantity - increment)));
      increase.addEventListener('click', () => change(item.key, item.quantity + increment));
      remove.addEventListener('click', () => change(item.key, 0));
      controls.append(decrease, quantity, increase, remove); details.append(controls); row.append(details); lines.append(row);
    }
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    renderOffer(cart);
    renderRecommendations(cart);
  }
  async function refresh() {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Your cart could not be loaded. Please open the cart page.');
      render(await response.json());
    })();
    try { await refreshing; } finally { refreshing = null; }
  }
  async function change(key, quantity) {
    if (busy) return;
    if (document.body.dataset.localPreview === 'true') { status.textContent = 'Local preview: your cart has not been changed.'; return; }
    lock(true); status.textContent = 'Updating your cart...';
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Your cart could not be updated.');
      render(cart); status.textContent = 'Cart updated.';
    } catch (error) {
      status.textContent = error.message;
      try { await refresh(); } catch { status.textContent += ' Please open the cart page to check your items.'; }
    } finally { lock(false); }
  }
  async function addUpsell(variantId, label) {
    if (busy || !variantId) return;
    if (document.body.dataset.localPreview === 'true') { status.textContent = 'Local preview: your cart has not been changed.'; return; }
    lock(true); status.textContent = 'Adding to your cart...';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
      await refresh();
      status.textContent = `${label || 'Item'} added to your cart.`;
    } catch (error) {
      status.textContent = error.message;
      try { await refresh(); } catch { status.textContent += ' Please open the cart page to check your items.'; }
    } finally { lock(false); }
  }
  async function open() {
    if (!drawer.open) { focusReturn = document.activeElement; drawer.showModal(); document.documentElement.classList.add('ulti-cart-open'); }
    status.textContent = 'Loading your cart...'; lock(true);
    try {
      if (document.body.dataset.localPreview === 'true') { render({ items: [], item_count: 0, total_price: 0 }); status.textContent = 'Local preview: live cart connections are disabled.'; }
      else { await refresh(); status.textContent = ''; }
    } catch (error) { status.textContent = error.message; const link = node('a', 'ulti-cart-view', 'Open cart page'); link.href = `${root}cart`; status.append(link); }
    finally { lock(false); }
  }
  drawer.querySelector('[data-cart-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    if (event.target === drawer) { const bounds = drawer.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close(); }
    const addButton = event.target.closest('[data-cart-upsell-add]');
    if (addButton) { event.preventDefault(); addUpsell(addButton.dataset.cartUpsellVariantId, addButton.closest('[data-cart-upsell]')?.querySelector('.ulti-cart-upsell-copy a')?.textContent?.trim()); }
  });
  drawer.addEventListener('close', () => { document.documentElement.classList.remove('ulti-cart-open'); focusReturn?.focus(); });
  checkout.addEventListener('click', event => { if (busy || document.body.dataset.localPreview === 'true') { event.preventDefault(); if (!busy) status.textContent = 'Local preview: checkout is disabled.'; } });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ulti-cart-open],a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.closest('#ulti-cart-drawer')) return;
    const url = link.href ? new URL(link.href, location.href) : null;
    if (link.matches('[data-ulti-cart-open]') || (url?.origin === location.origin && url.pathname === `${root}cart`)) { event.preventDefault(); open(); }
  });
  document.addEventListener('ulti:cart-added', open);
  document.addEventListener('ulti:cart-refresh', () => { if (drawer.open) refresh().catch(error => { status.textContent = error.message; }); });
}
